import { useTranslation } from "react-i18next";

import { Attachment } from "shared/api/api";
import { AttachmentType } from "shared/types";

import Card from "features/components/Card";

import Attachments from "./Attachments";
import { ATTRIBUTE_CARD_TITLE_CLASSES } from "./constants";

interface Props {
  resourceType: AttachmentType;
  itemID: string;
  itemName: string;
  attachments: Attachment[];
}

const AttachmentsCard = ({
  resourceType,
  itemID,
  itemName,
  attachments,
}: Props) => {
  const { t } = useTranslation("common");

  return (
    <Card className="flex flex-col !p-0">
      <div className={ATTRIBUTE_CARD_TITLE_CLASSES}>
        {t("attachments.documents")}
      </div>
      <div className="p-3">
        <Attachments
          resourceType={resourceType}
          itemID={itemID}
          itemName={itemName}
          attachments={attachments}
        />
      </div>
    </Card>
  );
};

export default AttachmentsCard;
